/**
 * Onboarding modal queue.
 *
 * Several first-entry modals (install-bonus, payout announcement,
 * what's-new, game how-to) used to auto-open independently and stack on
 * top of each other. This tiny singleton serializes them: only one holds
 * the "slot" at a time. When it releases, the next-highest-priority
 * waiter is granted after a short gap.
 *
 * Usage:
 *   requestOnboardingSlot('install-bonus', 30, () => setOpen(true));
 *   releaseOnboardingSlot('install-bonus'); // on dismiss
 */

const waiting = []; // [{ id, priority, onGrant }]
let current = null; // id currently holding the slot
const GAP_MS = 300; // breather between one modal closing and the next opening

function tryGrant() {
    if (current || waiting.length === 0) return;
    waiting.sort((a, b) => b.priority - a.priority);
    const next = waiting.shift();
    current = next.id;
    try {
        next.onGrant();
    } catch (e) {
        current = null;
        console.warn('onboardingQueue onGrant failed', e);
        tryGrant();
    }
}

export function requestOnboardingSlot(id, priority, onGrant) {
    if (current === id || waiting.some((w) => w.id === id)) return;
    waiting.push({ id, priority, onGrant });
    tryGrant();
}

export function releaseOnboardingSlot(id) {
    if (current === id) {
        current = null;
        setTimeout(tryGrant, GAP_MS);
        return;
    }
    const idx = waiting.findIndex((w) => w.id === id);
    if (idx >= 0) waiting.splice(idx, 1);
}
